import { SxProps, Theme } from '@mui/material';

const tabStyle: SxProps<Theme> = {
  alignItems: 'center',
  borderBottom: 2,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  gap: (theme) => theme.spacing(1),
  height: '100%',
  padding: (theme) => theme.spacing(1.5, 2),
};

export const styles: Record<'container' | 'tab' | 'activeTab' | 'tabLabel', SxProps<Theme>> = {
  activeTab: {
    ...tabStyle,
    color: (theme) => theme.palette.primary.main,
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: '56px',
  },
  tab: {
    ...tabStyle,
    color: (theme) => theme.palette.gray[50],
  },
  tabLabel: {
    display: {
      sm: 'unset',
      xs: 'none',
    },
  },
};
